import React from "react";
import Components from "mpm-components";
import { Form, Divider } from "semantic-ui-react";

import Utilities from "mpm-config/Utilities";

export default ({ cessionProduit }) => {
  const acquereur = cessionProduit.entreposage ? cessionProduit.entrepotCPDTO :cessionProduit.acquereurCPDTO ;
    return (
      <Components.Regions.RegionWithHeader
        title="menu.cession.capture"
        headerColor="blue"
        headerSize="small"
      >
        <Form>
        <Form.Checkbox toggle disabled checked={cessionProduit.entreposage}  label="Choisir Entreposage"/>
          <Form.Group widths="equal">
            <Form.Input
              label="Numéro Cession Complet"
              disabled
              value={cessionProduit.numeroCessionComplet}
            />
            <Form.Input
              label="Date Cession "
              disabled
              value={cessionProduit.dateCession}
            />
  
            <Form.Input
              label="Date Système "
              disabled
              value={cessionProduit.dateSysteme}
            />
          </Form.Group>
          <Divider />
          <Form.Group widths="equal">
          <Form.Select
            label="Type Acquereur"
            options={Utilities.getTypeAcquereurCPDropDownOptions()}
            disabled
            value={acquereur.typeAcquereur}
          />
          <Form.Input
                label="Numéro Autorisation"
                disabled
                value={acquereur.numeroAutorisation}
              />
              <Form.Input
                label="Numéro Agrement"
                disabled
                value={acquereur.numeroAgrement}
              />
          </Form.Group>
  
          <Form.Group widths="equal">
            <Form.Input
              label={cessionProduit.entreposage ? "Login entropot" : "Login Acquéreur"}
              disabled
              value={acquereur.numeroAcquereur}
            />
            <Form.Input
                label={cessionProduit.entreposage ? "Prénom entropot" : "Prénom Acquéreur"}
                disabled
                value={acquereur.prenom}
              />

              <Form.Input
                label={cessionProduit.entreposage ? "Nom entropot" : "Nom Acquéreur"}
                disabled
                value={acquereur.nom}
              />
          </Form.Group>
  
          <Form.Input
            label={cessionProduit.entreposage ? "Raison Social entropot" : "Raison Social Acquéreur"}
            disabled
            value={acquereur.raisonSocialeFR}
          />
        </Form>
      </Components.Regions.RegionWithHeader>
    );
  };